export const FIRESTORE_USERS_TABLE = "users";
export const FIRESTORE_EVENTS_TABLE = "events";
export const FIRESTORE_FEED_POSTS_TABLE = "feedPosts";
export const FIRESTORE_NEWSLETTER_EMAILS_TABLE = "newsletterEmails";
export const FIRESTORE_HIRE_SPACE_EMAILS_TABLE = "hireSpaceEmails";
export const FIRESTORE_HIRE_REQUESTS_TABLE = "hireRequests";
